<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ contractorIcon }}</md-icon>
            </div>
            <add-button @add-click="addContractor"></add-button>
          </md-card-header>
          <md-card-content>
            <md-table
              v-model="contractors"
              class="table-striped"
              table-header-color="primary"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name">
                  <router-link
                    :to="{
                      name: 'Contractor',
                      params: { contractorId: item.id }
                    }"
                    >{{ item.name }}</router-link
                  >
                </md-table-cell>
                <md-table-cell md-label="Group Email">{{
                  item.email
                }}</md-table-cell>
                <md-table-cell class="text-right">
                  <edit-button
                    :isSmall="true"
                    @edit-click="editContractor(item.id)"
                  ></edit-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state
                md-label="No Contractors Found"
              ></md-table-empty-state>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Contractorlist",
  computed: {
    ...mapGetters({
      contractorIcon: "data-management-contractor/icon",
      contractors: "data-management-contractor/contractors"
    })
  },
  created() {
    this.$store.dispatch("data-management-contractor/getContractorListing");
  },
  methods: {
    editContractor(id) {
      this.$router.push({
        name: "Edit Contractor",
        params: { contractorId: id }
      });
    },
    addContractor() {
      this.$router.push({ name: "Add Contractor" });
    }
  }
};
</script>

<style>
.text-right .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}
</style>
